export default class FinanceSettlement {
  public capitalPaid: number = 0;

  public guaranteedFutureValue: number = 0;

  public settlementFigure: number = 0;

  public settlementFee: number = 0;
}
